<template>
    <div class="yq-es-query-field">
        <el-select class="yq-es-query-field-field" v-model="cachedValue.field" placeholder="字段">
            <el-option v-for="field in dataSource.fields" :key="field.name" :value="field.name"
                       :label="field.title"></el-option>
        </el-select>
        <el-select class="yq-es-query-field-op" v-model="cachedValue.op" placeholder="关系">
            <el-option v-for="op in opList" :key="op.value" :value="op.value" :label="op.label"></el-option>
        </el-select>
        <el-input class="yq-es-query-field-value" placeholder="关键词，多个关键词以空格分隔" v-model="cachedValue.value"></el-input>
    </div>
</template>

<script>
    export default {
        name: "EsQueryField",
        props: ['value', 'dataSource'],
        data() {
            return {
                cachedValue: JSON.parse(JSON.stringify(this.value)),
                opList: [
                    {value: 'all', label: '包含全部'},
                    {value: 'any', label: '包含任意'},
                    {value: 'ne', label: '不包含'}
                ]
            }
        },
        watch: {
            'value': {
                deep: true,
                handler: function (val) {
                    if (val.field === this.cachedValue.field && val.op === this.cachedValue.op
                        && val.value === this.cachedValue.value) {
                        return
                    }
                    this.cachedValue = JSON.parse(JSON.stringify(val))
                }
            },
            'cachedValue': {
                deep: true,
                handler: function(val) {
                    this.$emit('input', JSON.parse(JSON.stringify(val)))
                }
            }
        }
    }
</script>

<style scoped>
.yq-es-query-field{
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
}
    .yq-es-query-field-field{
        width: 100px;
        flex: none;
    }
    .yq-es-query-field-op{
        width: 100px;
        flex: none;
        margin-left: 5px;
    }
    .yq-es-query-field-value{
        flex: auto;
        margin-left: 5px;
    }
</style>
